<template>
  <div id="achievements">
    <Title title="成果管理" />
    <ErrorMessage :status="achievementApiData.status" :customMessage="achievementApiData.customMessage" />

    <AchievementList v-show="achievementApiData.status === 200" :showAll="true" :achievements="achievementList" :achievementTypes="achievementTypes" :achievementFields="achievementFields" @update="getAchievementList"></AchievementList>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Title from '@/components/Title.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import AchievementList from '@/components/AchievementList.vue'
import { getAchievementFieldsForAdmin } from '@/transformer/achievement'

export default {
  name: 'Achievements',

  components: {
    Title,
    ErrorMessage,
    AchievementList
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn,
      achievementTypes: state => state.Achievement.achievementTypes,
      achievementApiData: state => state.Achievement.listApiStatus
    }),
    ...mapGetters('Achievement/', ['achievementList']),
    achievementFields() {
      const achievementTypeList = this.achievementTypes.map((e) => {
        return { text: e.name, value: e.id }
      })
      return getAchievementFieldsForAdmin(true, achievementTypeList)
    }
  },
  methods: {
    getAchievementList() {
      this.$store.dispatch('Achievement/getAchievementList')
    }
  },
  mounted: function () {
    this.getAchievementList()
  }
}
</script>
